import { KortbetjeningText } from '@hooks/use-text';

import { SpendingLimitCategory } from './types';

export const prettyCategoryName = (category: SpendingLimitCategory, text: KortbetjeningText) => {
    if (category === SpendingLimitCategory.DailyLimit) {
        return text.spendingLimitsInputDailyTitle;
    }

    if (category === SpendingLimitCategory.MonthlyLimit) {
        return text.spendingLimitsInputMonthlyTitle;
    }

    if (category === SpendingLimitCategory.DailyLimitEcommerce) {
        return text.spendingLimitsEcommerceInputDailyTitle;
    }

    if (category === SpendingLimitCategory.MonthlyLimitEcommerce) {
        return text.spendingLimitsEcommerceInputMonthlyTitle;
    }

    return '';
};
